import { render } from "./SearchHome.vue?vue&type=template&id=b1a77f08"
import script from "./SearchHome.vue?vue&type=script&lang=js"
export * from "./SearchHome.vue?vue&type=script&lang=js"

import "./SearchHome.vue?vue&type=style&index=0&id=b1a77f08&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__